import { useNavigate } from 'react-router';
import { GraphIcon, ArrowSquareOutIcon } from '@phosphor-icons/react';
import { GraphView } from '~/features/memory/graph-view';
import { Tip } from '~/components/ui/tip';

export interface GraphVisualizationOutput {
  kind?: string;
  focal_id?: string;
  focal_name?: string;
  focal_type?: string;
  node_count?: number;
  edge_count?: number;
  truncated?: boolean;
  error?: string;
}

interface Props {
  output: GraphVisualizationOutput;
}

export function GraphVisualizationCard({ output }: Props) {
  const navigate = useNavigate();

  if (output.error || !output.focal_id) {
    return (
      <div className="border border-border rounded-lg px-3 py-2 text-xs text-muted-foreground flex items-center gap-2">
        <GraphIcon size={14} />
        <span>{output.error ?? 'Nothing to visualize.'}</span>
      </div>
    );
  }

  return (
    <div className="border border-border rounded-lg overflow-hidden bg-card">
      <div className="px-3 py-2 flex items-center gap-2 text-xs border-b border-border">
        <GraphIcon size={14} className="text-muted-foreground" />
        <span className="font-medium text-foreground truncate">{output.focal_name}</span>
        {output.focal_type && (
          <span className="text-muted-foreground/70 italic">{output.focal_type}</span>
        )}
        <span className="ml-auto text-muted-foreground">
          {output.node_count} nodes · {output.edge_count} edges
          {output.truncated ? ' · truncated' : ''}
        </span>
        <Tip label="Open in Memory view">
          <button
            type="button"
            onClick={() => navigate(`/memory?entity=${encodeURIComponent(output.focal_id!)}`)}
            className="text-muted-foreground hover:text-foreground transition-colors cursor-pointer"
            aria-label="Open in Memory view"
          >
            <ArrowSquareOutIcon size={13} />
          </button>
        </Tip>
      </div>
      <div className="p-2">
        <GraphView
          entityId={output.focal_id}
          onSelectEntity={(id) => navigate(`/memory?entity=${encodeURIComponent(id)}`)}
        />
      </div>
    </div>
  );
}
